import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { ReactComponent as Hemberger } from "../assets/icons/Hemberger.svg";
import { ReactComponent as UserIcon } from "../assets/icons/UserIcon.svg";
import Sidebar from "../sidenav/Sidenav";
import {
  Button,
  Table,
  Collapse,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  FormControl,
} from "@mui/material";
import styles from "./testimonialsMobile.module.css";
import WarningIcon from "../assets/Alert.svg";
import { ArrowBackIosNewRounded } from "@mui/icons-material";
import axios from "axios";
import { toast } from "react-toastify";
import isDesktop from "../isDesktop";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import { tableCellClasses } from "@mui/material/TableCell";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import TextEditor from "../Components/TextEditor/TextEditor";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { getFilenameFromS3Url } from "../utils/urlUtils";
import UploadImageInput from "../Components/UploadImage/UploadImageInput";
import { hasStoredTabAccess } from '../utils/access';

const TestimonialsMobile = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const navigate = useNavigate();
  const closeSidebar = () => {
    setIsSidebarOpen(false);
  };
  const [open, setOpen] = useState(false);
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [testimonials, setTestimonials] = useState([]);
  const [openWarning, setOpenWarning] = useState(false);
  const [toDelete, setToDelete] = useState("");
  const [inputData, setInputData] = useState({
    t_name: "",
    t_class: "",
    t_image_url: "",
    t_description: "",
  });
  const [imageData, setImageData] = useState(null);
  const [imagename, setImageName] = useState("");
  const [selectedId, setSelectedId] = useState("");
  const isAuthorized = hasStoredTabAccess('Success Stories');

  const handleClick = () => {
    setOpen(true);
  };

  const handleImageChange = (file) => {
    console.log(file, "Image File");

    const formData = new FormData();
    formData.append("image", file);
    setImageData(formData);
    setImageName(file.name);
  };

  const onWarningOpen = (id) => {
    setOpenWarning(true);
    setToDelete(id);
  };

  const onWarningClose = () => {
    setOpenWarning(false);
    setToDelete("");
  };

  function Row(props) {
    const { row } = props;
    const [open, setOpen] = React.useState(false);

    return (
      <React.Fragment>
        <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
          <TableCell component="th" scope="row">
            <div>{row?.testimonial_id}</div>
          </TableCell>
          <TableCell component="th" scope="row">
            <div>{row?.t_name}</div>
          </TableCell>
          <TableCell style={{ textAlign: "end" }}>
            <IconButton
              aria-label="expand row"
              style={{ color: "black" }}
              size="small"
              onClick={() => setOpen(!open)}
            >
              {open ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
            </IconButton>
          </TableCell>
        </TableRow>
        <TableRow
          sx={{
            "& td": { border: 0, height: open ? "auto" : 0 },
            borderBottom: "1px solid black",
          }}
        >
          <TableCell
            style={{ paddingBottom: 0, paddingTop: 0, borderTop: "none" }}
            colSpan={6}
          >
            <Collapse in={open} timeout="auto" unmountOnExit>
              <div
                style={{
                  fontSize: "10px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginBottom: "0.5rem",
                }}
              >
                <div style={{ flex: "1" }}>Actions:</div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "0.4rem",
                  }}
                >
                  <Button
                    onClick={() => {
                      handleClickEdit(row?.testimonial_id);
                    }}
                    className="actionMobileBtn"
                    style={{
                      backgroundColor: "#D1F4DE",
                      color: "black",
                    }}
                  >
                    Edit
                  </Button>
                  <Button
                    onClick={() => {
                        onWarningOpen(row.testimonial_id);
                    }}
                    className="actionMobileBtn"
                    style={{
                      backgroundColor: "#FFD6D2",
                      color: "black",
                    }}
                  >
                    Delete
                  </Button>
                </div>
              </div>
            </Collapse>
          </TableCell>
        </TableRow>
      </React.Fragment>
    );
  }

  const onUpdateSubmit = async (e) => {
    e.preventDefault();
    try {
      let imageResponse;
      if (imageData) {
        imageResponse = await axios.post(
          `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_KEY}/file/upload`,
          imageData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
      }
      const response = await axios.put(
        `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_KEY}/testimonials/update/${selectedId}`,
        {
          t_name: inputData.t_name,
          t_class: inputData.t_class,
          t_image_url: !imageData
            ? inputData.imageURL
            : imageResponse.data.imageUrl,
          t_description: inputData.t_description,
        }
      );

      if (response.status === 200) {
        toast.success("Testimonial Updated Successfully");
        handleCloseDialog();
        getAllTestimonials();
      }
    } catch (error) {
      console.error(error);
      toast.error("Error Updating Testimonial");
    }
  };

  const onAddClick = async (e) => {
    e.preventDefault();
    try {
      let imageResponse;
      if (!imageData) {
        toast.error("Please upload an image");
      }
      imageResponse = await axios.post(
        `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_KEY}/file/upload`,
        imageData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_KEY}/testimonials/add`,
        {
          t_name: inputData.t_name,
          t_class: inputData.t_class,
          t_image_url: imageResponse.data.imageUrl,
          t_description: inputData.t_description,
        }
      );

      if (response.status === 200) {
        toast.success("Testimonial Updated Successfully");
        handleCloseDialog();
        getAllTestimonials();
      }
    } catch (error) {
      console.error(error);
      toast.error("Error Updating Testimonial");
    }
  };

  const handleClickEdit = async (id) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_KEY}/testimonials/data/${id}`
      );

      if (response.status === 200) {
        const testi = response.data.data;
        // console.log(testi);

        setInputData({
          t_name: testi?.t_name,
          t_class: testi?.class,
          t_image_url: testi?.image_url,
          t_description: testi?.description,
        });
        setImageName(getFilenameFromS3Url(testi.image_url));
        setSelectedId(testi?.testimonial_id);
        setOpenEditDialog(true);
      }
    } catch (error) {
      console.error(error);
      toast.error(
        "Error Fetching Skill Data to Update",
        error.response.data.message
      );
    }
  };

  const handleClickDelete = async () => {
    try {
      const response = await axios.delete(
        `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_KEY}/testimonials/delete/${toDelete}`
      );

      if (response.status === 200) {
        toast.success("Testimonial Deleted Successfully");
        getAllTestimonials();
        setOpenWarning(false);
      }
    } catch (error) {
      console.error(error);
      toast.error("Error Deleting Testimonial");
    }
  };

  const handleCloseDialog = () => {
    setOpen(false);
    setOpenEditDialog(false);
    setInputData({
      t_name: "",
      t_class: "",
      t_image_url: "",
      t_description: "",
    });
    setSelectedId("");
    setImageData(null);
    setImageName("");
  };

  const InputChangeHandler = (e) => {
    const name = e.target.name;
    setInputData((prev) => ({
      ...prev,
      [name]: e.target.value,
    }));
  };

  const getAllTestimonials = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_KEY}/testimonials/all`
      );

      if (response.status === 200) {
        setTestimonials(response.data.data);
      }
    } catch (error) {
      console.error(error);
      toast.error(error.response.data.message);
    }
  };

  useEffect(() => {
    getAllTestimonials();
  }, []);

  const onTestimonialDescriptionChange = (value) => {
    setInputData((prev) => {
      return {
        ...prev,
        t_description: value,
      };
    });
  };

  if (!isAuthorized) {
    return (
      <div className="container-fluid mt-5">
        <h2 style={{ marginTop: "2rem" }}>
          You are unauthorized to access this page
        </h2>
      </div>
    );
  }

  return (
    <>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          margin: "0.5rem 0.75rem 1.25rem 0.75rem",
        }}
      >
        <div
          onClick={() => setIsSidebarOpen(!isSidebarOpen)}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            width: "36px",
            height: "36px",
            borderRadius: "18px",
            background: "#EAF1F7",
          }}
        >
          <Hemberger />
        </div>
        <Link to={"/profile"}>
          <UserIcon style={{ cursor: "pointer" }} />
        </Link>
      </div>
      <Sidebar isOpen={isSidebarOpen} onClose={closeSidebar} />
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          margin: "0rem 0.75rem 1.5rem 0.75rem",
        }}
      >
        <div className="container-fluid">
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: "2.25rem",
            }}
          >
            <div
              style={{
                display: "flex",
                gap: "1vw",
                alignItems: "center",
              }}
            >
              <ArrowBackIosNewRounded
                onClick={() => {
                  navigate("/dashboard");
                }}
                style={{ cursor: "pointer" }}
              />
              <h4 style={{ marginRight: "1rem", marginBottom: "0px" }}>
              Success Stories
              </h4>
            </div>
            <Button
              onClick={handleClick}
              className="button-two"
              style={{
                width: "6rem",
                height: "1.75rem",
                background: "#37446F",
              }}
            >
              Add
            </Button>
          </div>
          <Table
            aria-label="collapsible table"
            sx={{
              [`& .${tableCellClasses.root}`]: {
                borderBottom: "none",
              },
            }}
          >
            <TableHead
              style={{
                height: "44px",
                borderRadius: "4px !important",
                background: "rgba(234, 241, 247, 1)",
                boxShadow: "2px 2px 4px 0px rgba(174, 174, 192, 0.5)",
              }}
            >
              <TableRow>
                <TableCell>S. No.</TableCell>
                <TableCell>Voucher Name</TableCell>
                <TableCell />
              </TableRow>
            </TableHead>
            <TableBody>
              {testimonials?.map((brand, ind) => (
                <Row key={ind} row={brand} />
              ))}
            </TableBody>
          </Table>
        </div>
      </div>
      <Dialog open={open} onClose={handleCloseDialog}>
        <DialogTitle sx={{ fontSize: "1.154vw", fontWeight: "600" }}>
          Add New Success Story
        </DialogTitle>
        <DialogContent>
          <div className="dialog-fields">
            <TextField
              className="customTextfield"
              type="text"
              label="Name"
              name="t_name"
              value={inputData.t_name}
              variant="outlined"
              sx={{
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "transparent",
                  },
                  "&:hover fieldset": {
                    borderColor: "transparent",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "transparent",
                  },
                },
                marginBottom: "0.625rem",
              }}
              onChange={InputChangeHandler}
            />
            <TextField
              className="customTextfield"
              type="text"
              label="Class"
              name="t_class"
              value={inputData.t_class}
              variant="outlined"
              sx={{
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "transparent",
                  },
                  "&:hover fieldset": {
                    borderColor: "transparent",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "transparent",
                  },
                },
                marginBottom: "0.625rem",
              }}
              onChange={InputChangeHandler}
            />
            <UploadImageInput
              fileName={imagename}
              handleFileChange={handleImageChange}
            />
          </div>
          <div
            style={{
              marginTop: "0.625rem",
              marginBottom: "0.625rem",
            }}
          >
            <TextEditor
              propsContent={inputData.t_description}
              propPlaceholder={"Short Description...."}
              onChangeContent={onTestimonialDescriptionChange}
            />
          </div>
          <div className="dialog-actions-box">
            <Button className="outlined-button" onClick={handleCloseDialog}>
              Cancel
            </Button>
            <Button className="filled-button" onClick={onAddClick}>
              Add
            </Button>
          </div>
        </DialogContent>
      </Dialog>
      <Dialog open={openEditDialog} onClose={handleCloseDialog}>
        <DialogTitle sx={{ fontWeight: "600" }}>
          Edit Success Story
        </DialogTitle>
        <DialogContent>
          <div className="dialog-fields">
            <TextField
              className="customTextfield"
              type="text"
              label="Name"
              name="t_name"
              variant="outlined"
              value={inputData.t_name}
              sx={{
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "transparent",
                  },
                  "&:hover fieldset": {
                    borderColor: "transparent",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "transparent",
                  },
                },
                marginBottom: "0.625rem",
              }}
              onChange={InputChangeHandler}
            />
            <TextField
              className="customTextfield"
              type="text"
              label="Class"
              name="t_class"
              value={inputData.t_class}
              variant="outlined"
              sx={{
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "transparent",
                  },
                  "&:hover fieldset": {
                    borderColor: "transparent",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "transparent",
                  },
                },
                marginBottom: "0.625rem",
              }}
              onChange={InputChangeHandler}
            />
            <UploadImageInput
              fileName={imagename}
              handleFileChange={handleImageChange}
            />
          </div>
          <div
            style={{
              marginTop: "0.625rem",
              marginBottom: "0.625rem",
            }}
          >
            <TextEditor
              propsContent={inputData.t_description}
              propPlaceholder={"Short Description...."}
              onChangeContent={onTestimonialDescriptionChange}
            />
          </div>
          <div className="dialog-actions-box">
            <Button className="outlined-button" onClick={handleCloseDialog}>
              Cancel
            </Button>
            <Button className="filled-button" onClick={onUpdateSubmit}>
              Update
            </Button>
          </div>
        </DialogContent>
      </Dialog>
      <Dialog open={openWarning} onClose={onWarningClose}>
        <DialogContent className={styles.warningDialogContent}>
          <div className={styles.warningIconContainer}>
            <img src={WarningIcon} />
          </div>
          <div className={styles.warningTextContainer}>
            <h2>Are You Sure?</h2>
            <h5>You won't be able to revert this.</h5>
          </div>
          <DialogActions>
            <Button
              className="outlined-button"
              style={{ width: "7.692vw", height: "2.308vw" }}
              onClick={() => {
                setOpenWarning(false);
              }}
            >
              Cancel
            </Button>
            <Button className="filled-button" onClick={handleClickDelete}>
              Delete
            </Button>
          </DialogActions>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default TestimonialsMobile;
